import { useEffect, useState } from 'react';

export const useWindowCloseMsg = (resultListData) => {   
  const count = resultListData ? resultListData.filter(item => item.operation).length : 0;

  useEffect(() => {
    const handleBeforeUnload = (event) => {  
      if (count < 1) return;      

      const defaultFlag=true;
      // 표준 방식: returnValue 설정
      event.returnValue = defaultFlag;
      // 일부 브라우저에서 적용이 안되는 경우 호환성 유지를 위해 남김
      return defaultFlag;
    };

    const handleUnload = () => { console.log("windows close")  }; //실제 창이 닫힐 때 실행 (제한적)  
    window.addEventListener('beforeunload', handleBeforeUnload);
    window.addEventListener('unload', handleUnload);

     // 일부 브라우저에서 적용이 안되는 경우 호환성 유지를 위해 남김
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
      window.removeEventListener('unload', handleUnload);
    };
  }, [count]);
}